module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 56
// module chunks = 25